import { Component, OnInit, ViewChild } from '@angular/core';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { TestimonialModel } from '../../models/testimonial.model';
import { TestimonialService } from '../../services/testimonial.service';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { environment } from 'src/environments/environment';
import { CarouselResize } from 'src/app/shared/models/carousel-resize';
import { CustomCarouselComponent } from 'src/app/shared/components/custom-carousel/custom-carousel.component';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {
  isRtl: boolean = true;
  mediaUrl: string = environment.mediaUrl;
  carouselResize: CarouselResize<TestimonialModel> = {
    data: [],
    items: [],
    itemSizeSm: 1,
    itemSizeMd: 2,
    itemSizeLg: 3,
    itemResize: 0,
    innerWidth: 0,
    currentIndex: 0,
    slideDelay: 10000
  }
  @ViewChild('appCustomCarousel') appCustomCarousel: CustomCarouselComponent<TestimonialModel>;
  constructor(private testimonialService: TestimonialService, private _LanguageService:LanguageService, private _IdentityService: IdentityService){}

  /** Unified Code mode: tokenised layout (styles/unified-code/components/_home.scss). */
  get isUnified(): boolean {
    return this._IdentityService.isUnifiedCode();
  }

  ngOnInit(): void {
    this.isRtl = this._LanguageService.getCurrentLanguage() === LanguageEnum.ar;
    this._LanguageService.languageChange.subscribe((result: LanguageEnum) => this.isRtl = result === LanguageEnum.ar);
    this.getTestimonial();
  }
  getTestimonial(): void {
    this.testimonialService.getActiveList().subscribe({
      next: (data: TestimonialModel[]) => this.carouselResize.data = data
    });
  }
}
